import {Component, QueryList, ViewChildren} from '@angular/core';
import {DateTime, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, Util} from '../../../app/util';
import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {
    ENUM,
    TAction,
    TPaymentFlag,
} from "../../../app/enum";
import {ModalActionPage} from "../modal-action/modal-action";
import {PaybookRepo} from '../../../repositories/payment-repo';


@Component({
    selector: 'page-payment-menu',
    templateUrl: 'payment-menu.html',
    providers: [ProfileService, HotspotService, PaybookRepo]
})
export class PaymentMenuPage {

    TPaymentFlag: any = TPaymentFlag;

    enum: any = ENUM;
    config: any;
    logado: any;

    profile: any;
    branded: any;
    userset: any;
    peylink: any;
    paybook: any;

    indexPL: number;
    indexPJ: number;
    indexPA: number;

    etapa: number;

    hotspotID: number;
    monitorBool: boolean;

    detalheBool: boolean;

    @ViewChildren(DateTime) iondates: QueryList<DateTime>;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public hotspotService: HotspotService,
                public viewCtrl: ViewController, public util: Util,
                public logadoService: LogadoService,
                public paybookRepo: PaybookRepo) {


        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.profile = this.navParams.get('profile');
        this.branded = this.navParams.get('branded');
        this.userset = this.navParams.get('userset');
        this.paybook = this.navParams.get('paybook');

        this.indexPL = this.navParams.get('indexPL');
        this.indexPJ = this.navParams.get('indexPJ');
        this.indexPA = this.navParams.get('indexPA');

        this.hotspotID = this.navParams.get('hotspotID');

        this.monitorBool = this.navParams.get('monitorBool');

        if (this.etapa == 4) this.peylink = this.paybook.Parcelas[this.indexPL].Payjoins[this.indexPJ];
        if (this.etapa == 5) this.peylink = this.paybook.Parcelas[this.indexPL].Payjoins[this.indexPJ];

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Payment Menu', '/payment-menu');

    }




    /** ************************************************ PAYBOOK ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    getTitle() {

        if (this.etapa == 4) return this.util.dataft(this.paybook.Parcelas[this.indexPL].Payjoins[this.indexPJ].Payments[0].PaymentCria);
        if (this.etapa == 5) return this.util.dinheiro(this.peylink.Payments[this.indexPA].PaymentCash + this.peylink.Payments[this.indexPA].PaymentJuro + this.peylink.Payments[this.indexPA].PaymentPena + this.peylink.Payments[this.indexPA].PaymentMore);

    }

    paymentTopo() {

        if (this.etapa == 4) return 'CorMenu';
        if (this.etapa == 5) return 'CorRoxa';

    }





    /** ************************************************ PAYMENT ************************************************** **/
    /** ************************************************ setuper ************************************************** **/

    paymentInfo(payment) {

        let indexPA = this.peylink.Payments.indexOf(payment);
        let object = {etapa: 5, userset: this.userset, paybook: this.paybook, indexPL: this.indexPL, indexPJ: this.indexPJ, indexPA: indexPA};
        this.util.modalopen(PaymentMenuPage, 'quad', true, object).subscribe();

    }

    paymentEsto(payjoin, that) {

        let onBack = (data) => {

            //Add payjoin.Payments pgto estornado
            let payitem = this.util.deepCopy(this.paybook.Parcelas[this.indexPL].Payjoins[this.indexPJ]);
            payitem.Payments[0].PaymentID = data.Codigo;
            payitem.Payments[0].EstornoID = payjoin.Payments[0].PaymentID;
            payitem.Payments[0].PaymentFlag = TPaymentFlag.cpEstornado;
            payitem.Payments[0].PaymentCria = this.util.dateToStr(null, true).split(' ')[0];
            payitem.Payments[0].PaymentPago = this.util.dateToStr(null, false).split(' ')[0];
            payitem.Payments[0].PaymentWill = payitem.Payments[0].PaymentPago;
            payitem.Payments[0].PaymentCash = (payitem.Payments[0].PaymentCash * -1);
            payitem.Payments[0].PaymentText = paymentText;

            payjoin.Payments[0].EstornoID = payjoin.Payments[0].PaymentID;
            this.paybook.Parcelas[this.indexPL].Payjoins.unshift(payitem);
            
            this.dismiss();
            if (that) that.dismiss();

        }


        //Pedir justificativa, devera ser pronta?
        let paymentText = '';


        //REQUEST
        let loading = this.util.loadingDots();
        loading.present();

        let params = '&PaymentID=' + payjoin.Payments[0].PaymentID + '&PaymentAuth=' + payjoin.Payments[0].PaymentAuth + '&PaymentText=' + paymentText;
        this.util.monitorDesk(this.monitorBool, 'DESK-Payment', this.paybook.HotspotID, params, TAction.acLixo)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onBack(data),
                erro => this.util.alertResult(erro)
            );

        //#BRIDGE
        // this.hotspotService.payment(TAction.acLixo, 0, 0, payjoin.Payments[0].PaymentAuth)
        //     .finally(() => loading.dismiss())
        //     .subscribe(
        //         data => that.dismiss(),  //Add payjoin.Payments pgto estornado
        //         erro => this.util.alertResult(erro)
        //     );

    }

    paymentBack(payjoin) {

        let onDone = () => {

            let onOkey = (okey, that, data) => this.paymentEsto(payjoin, that);
            let objectData = {modalinfo: this.config.modalinfo(this.util, 'estorno', onOkey)};
            this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

        };

        let onBack = () => {

            let onOkey = (okey, that, data) => console.log('Requisição, informando chargeback');
            let objectData = {modalinfo: this.config.modalinfo(this.util, 'gatecharge', onOkey)};
            this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

        };

        let onMore = () => {

            let onCoin = () => {

                let onSave = (cash) => {
                    let hoje = this.util.dateToStr();
                    let payment = {PaymentID: 0, PaymentFlag: TPaymentFlag.cpEstornado, PaymentCash: -cash, PaymentJuro: 0, PaymentPena: 0, PaymentMore: 0, PaymentCria: hoje, PaymentPago: hoje, PaymentWill: hoje};
                    payjoin.Payments.push(payment);
                };

                let cash = this.util.jsSum(payjoin.Payments, ['PaymentCash'], 'PaymentFlag', this.paybookRepo.TPaymentJoin);
                this.util.pickerCash(1, cash, 1, cash, onSave);

            };


            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Dinheiro', handler: () => onCoin()});
            buttons.push({text: 'Bancário', handler: () => onCoin()});
            this.util.sheetOpen(buttons, 'DEVOLUÇÃO');

        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Estorno',     handler: () => onDone()});
        buttons.push({text: 'Chargeback',  handler: () => onBack()});
        buttons.push({text: 'Outros',      handler: () => onMore()});
        this.util.sheetOpen(buttons, 'DEVOLUÇÃO');

    }




    dismiss() {

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss({}, 'back');
            return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/payment-menu/payment-menu.ts